/** Mediamagneten whitelabel theme entry. */

import type { WhitelabelThemeEntry } from '../../types';
import { mediamagDefaultTheme } from './default';

export { mediamagWhitelabel } from './default';

export const mediamagWhitelabelThemeEntry: WhitelabelThemeEntry = {
  themes: {
    default: mediamagDefaultTheme,
  },
};
